import { IeLynxObject } from "../../common/models/eLynxObject";

export const keys = {
    all: ["run-tickets"],
    lists: () => [
        ...keys.all,
        "list"
    ],
    list: (
        customerID: number,
        groupID: number,
        eLynxObject: IeLynxObject,
        offline: boolean,
        timestamp?: Date
    ) => [
            ...keys.lists(),
            {
                customerID,
                groupID,
                eLynxObject,
                offline,
                timestamp
            }
        ],
    tankLists: () => [
        ...keys.all,
        "tank-list"
    ],
    tankList: (
        customerID: number,
        groupID: number,
        eLynxObject: IeLynxObject,
        offline: boolean,
        timestamp?: Date
    ) => [
            ...keys.tankLists(),
            {
                customerID,
                groupID,
                eLynxObject,
                offline,
                timestamp
            }
        ]
};
